import { tv } from 'tailwind-variants';

export const toolbarButtonItemRecipe = tv({
  base: 'flex items-center justify-center h-6 w-6 rounded-[.25rem]',
  variants: {
    variant: {
      default: 'text-brand-gray-14 dark:text-brand-gray-12',
      inverse: 'text-brand-gray-8 dark:text-brand-gray-12',
    },
    isActive: {
      true: '',
      false: '',
    },
    isDisabled: {
      true: 'opacity-50 cursor-not-allowed',
      false: '',
    },
  },
  compoundVariants: [
    {
      variant: 'default',
      isActive: true,
      className: 'bg-brand-black-alpha-5 dark:bg-brand-black-alpha-11',
    },
    {
      variant: 'inverse',
      isActive: true,
      className: 'bg-brand-gray-14 dark:bg-brand-gray-14',
    },
    {
      variant: 'default',
      isDisabled: false,
      className:
        'cursor-pointer hover:bg-brand-black-alpha-5 active:bg-brand-black-alpha-7 dark:hover:bg-brand-black-alpha-10 dark:active:bg-brand-black-alpha-11',
    },
    {
      variant: 'inverse',
      isDisabled: false,
      className: [
        'cursor-pointer hover:bg-brand-gray-14 active:bg-brand-gray-14',
        'dark:hover:bg-brand-gray-14 dark:active:bg-brand-gray-14',
      ],
    },
  ],

  defaultVariants: {
    variant: 'default',
    isActive: false,
    isDisabled: false,
  },
});
